var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// main handler for this mixin
import { Const } from './provider/candle-history/lib/const.cls';
import { mapActions } from 'vuex';
import { finView } from './lib/finView.cls';
import * as finViewStoreExtensions from './provider/candle-history';
// add plugin store extensions to store properties
var state = __assign({}, finViewStoreExtensions.stateExt);
var actions = __assign({}, finViewStoreExtensions.actionsExt);
var mutations = __assign({}, finViewStoreExtensions.mutationsExt);
var getters = __assign({}, finViewStoreExtensions.gettersExt);
// new store module definition
var finViewStore = {
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
};
// main mixin to load the new store module
export var finViewMixins = {
    created: function () {
        // dynamically extend store with scalpertStore plugin
        var _store = this.$store;
        if (!(_store && _store.state && _store.state[finView.STORE_MODULE_NAME])) {
            this.$store.registerModule(finView.STORE_MODULE_NAME, finViewStore);
        }
    },
    methods: __assign(__assign({}, mapActions({
        _runGetUserWatchList: Const.RUN_USER_WATCH_LISTING,
        _runGetCategoriesList: Const.RUN_CATEGORIES_LISTING,
        _runGetArticelsList: Const.RUN_ARTICELS_LISTING,
        _runUserReview: Const.RUN_USER_REVIEW,
        _runGetUserIdFromClientCode: Const.RUN_GET_USER_ID_FROM_CLIENTCODE,
        _runGetComplaintsData: Const.RUN_GET_COMPLAINTS_DATA,
    })), { computedCommonFunc: function (getFuncName) {
            try {
                return this.$store.getters[getFuncName];
            }
            catch (ex) {
                return [];
            }
        } }),
    computed: {
        compalintsData: function () { return this.computedCommonFunc(Const.GET_COMPLAINTS_DATA); },
    },
    mounted: function () {
    },
};
// export all mixins for data-warehouse plugin



//////////////////
// WEBPACK FOOTER
// ./src/plugins/finView/index.ts
// module id = null
// module chunks = 